/* src/app/feature-modules/session-engagement/components/pre-engagement/pre-engagement.component.css */
.hug-tutor-attempts__confitti {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 0;
  display: block;
  height: auto !important;
}
.hide {
  visibility: hidden;
}
.miro-btn {
  font-size: 20px;
  height: 52px;
  min-width: 292px;
}
.tutor-db-miro-wrap .miro-btn {
  height: 100%;
}
.tm-symbol {
  color: black;
}
.hug-text {
  font-size: 18px;
}
.quick-help {
  background: #fff49c;
  padding: 8px 16px;
  border-radius: 4px;
  color: #6b4600;
  margin-bottom: 8px;
  font-size: 14px;
  margin-top: -4px;
  border: 1px solid #d3c871;
}
.hug-tutor-smiley__text {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  text-align: center;
  margin-top: 32px;
  font-weight: 400;
  font-size: 18px;
}
.hug-tutor-confirm {
  background-color: #fff;
  z-index: 1;
}
.hug-header {
  z-index: 1000;
}
.hug-tutor-attempts {
  position: inherit !important;
}
/*# sourceMappingURL=pre-engagement.component.css.map */
